import styled from '@benzinga/themetron';
import { Row } from '../../../../../styles';

interface ChartRangeProps {
  $sign: -1 | 0 | 1 | number;
}

const ChartRangeWrapper = styled(Row)<ChartRangeProps>`
  color: ${props =>
    props.$sign > 0
      ? props.theme.colors.statistic.positive
      : props.$sign < 0
        ? props.theme.colors.statistic.negative
        : props.theme.colors.foregroundInactive};
  font-size: 12px;
  margin-left: 1em;
  white-space: nowrap;
`;

export { ChartRangeWrapper };
